var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "current",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Paragraph / unorderedList"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 8.375C2.4 8.375 1.875 8.9 1.875 9.5C1.875 10.1 2.4 10.625 3 10.625C3.6 10.625 4.125 10.1 4.125 9.5C4.125 8.9 3.6 8.375 3 8.375ZM3 4.625C2.4 4.625 1.875 5.15 1.875 5.75C1.875 6.35 2.4 6.875 3 6.875C3.6 6.875 4.125 6.35 4.125 5.75C4.125 5.15 3.6 4.625 3 4.625ZM3 12.125C2.4 12.125 1.875 12.65 1.875 13.25C1.875 13.85 2.4 14.375 3 14.375C3.6 14.375 4.125 13.85 4.125 13.25C4.125 12.65 3.6 12.125 3 12.125ZM5.625 5V6.5H16.125V5H5.625ZM5.625 14H16.125V12.5H5.625V14ZM5.625 10.25H16.125V8.75H5.625V10.25Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unordered-list.8775468f54ed060f4e00041c62b971fd.svg";
export { ForwardRef as ReactComponent };